import React, { useContext, useEffect, useLayoutEffect, useState } from 'react';
import { MdEdit, MdDelete } from 'react-icons/md';

import * as S from './styles';
import { color } from 'styles/pallete';
import MobileBody from 'components/MobileBody';
import DynamicPageContext from 'context/DynamicPage';
import Load from 'components/Load';
import { SortableItem } from 'components/DnDSortalbe/SortableItem';
import WindowSize from 'types/WindowSize';
import useWindowSize from 'hooks/useWindowSize';
import { FaSave } from 'react-icons/fa';
import { MdOutlinePublishedWithChanges } from 'react-icons/md';
import { ItemDynamicPageInPhone } from 'types/ItemDynamicPageInPhone';
import {
	getcomponentsBySlug,
	deleteModuleFromBack,
	refreshPositionItens
} from './reqs';
import SystemNotifyContext from 'context/SystemNotifyContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import { returnInterfaceBySlug } from './functions';

interface MobileDynamicPageProps {
	isDragging: boolean;
}

export default function MobileDynamicPage({
	isDragging
}: MobileDynamicPageProps) {
	const { setIsOpenLoad, setMessage } = useContext(LoadGeneralContext);
	const { handleNotify } = useContext(SystemNotifyContext);
	const { width, height }: WindowSize = useWindowSize();
	const {
		isLoad,
		setIsLoad,
		setItensOnPhone,
		setItensOnPhoneBackup,
		itensOnPhone,
		setIsFormOpen,
		setTypeItemToAdd,
		dynamicPageSelected,
		setModuleOnPhoneToEdit,
		itensOnPhoneBackup
		// moduleInSavingMode,
		// moduleOnPhoneToEdit,
		// canSaveModuleOnBack
	} = useContext(DynamicPageContext);

	const [isEqual, setIsEqual] = useState(true);

	// console.log('✌️canSaveModuleOnBack --->', canSaveModuleOnBack);
	// console.log('✌️moduleInSavingMode --->', moduleInSavingMode);
	// console.log('✌️moduleOnPhoneToEdit --->', moduleOnPhoneToEdit);
	// console.log('===========================');

	function returnWidthPhone() {
		if (width !== undefined && height !== undefined) {
			if (width > 2000) {
				return '380px';
			}
			if (width > 1950) {
				return '18vw';
			}
			if (width > 1700) {
				return '17vw';
			}
			if (height < 800) {
				return '19vw';
			}
			if (width > 1200) {
				return '22vw';
			}
		} else {
			return '270px';
		}
	}

	function returnHeihtPhone() {
		if (height !== undefined) {
			if (height >= 1000) {
				return '70vh';
			}

			if (height < 1000) {
				return '77vh';
			}
		} else {
			return '270px';
		}
	}

	function toogleSelectModuleToEditOrDelete(
		item: ItemDynamicPageInPhone,
		state: boolean
	) {
		const newList = itensOnPhone.map((value) => {
			if (value.id === item.id) {
				value.isEdit = state;
			}
			return value;
		});

		setItensOnPhone(newList);
	}

	function editItem(item: ItemDynamicPageInPhone) {
		setTypeItemToAdd(item.slug);
		setModuleOnPhoneToEdit(item);
		setIsFormOpen(true);
	}

	async function deleteItem(item: ItemDynamicPageInPhone) {
		if (dynamicPageSelected !== null) {
			setMessage('Deletando módulo');
			setIsOpenLoad(true);

			const { isSuccess } = await deleteModuleFromBack(
				item.id,
				dynamicPageSelected.slug,
				handleNotify
			);

			setIsOpenLoad(false);

			if (isSuccess) {
				const newList = itensOnPhone.filter((value) => value.id !== item.id);
				setItensOnPhone(newList);
				setItensOnPhoneBackup(newList);
			}
		}
	}

	function checkIfOrderMobileListWareChanged() {
		setIsEqual(true);
		if (JSON.stringify(itensOnPhone) === JSON.stringify(itensOnPhoneBackup)) {
			setIsEqual(true);
		} else {
			setIsEqual(false);
		}
	}

	async function saveIntensPosition() {
		setMessage('Salvando lista de módulos');
		setIsOpenLoad(true);
		const { isSuccess } = await refreshPositionItens(
			itensOnPhone,
			dynamicPageSelected?.slug || '',
			handleNotify
		);

		if (isSuccess) {
			setItensOnPhoneBackup(itensOnPhone);
		}

		setIsOpenLoad(false);
	}

	//verifica se é necessário salvar ou não a lista dentro do celular
	useLayoutEffect(() => {
		checkIfOrderMobileListWareChanged();
	}, [itensOnPhone, itensOnPhoneBackup]);

	useEffect(() => {
		(async () => {
			if (dynamicPageSelected && dynamicPageSelected.slug !== '') {
				setIsLoad(true);
				const { data, isSuccess } = await getcomponentsBySlug(
					dynamicPageSelected.slug,
					handleNotify
				);
				setIsLoad(false);
				if (isSuccess && data) {
					setItensOnPhone(data);
					setItensOnPhoneBackup(data);
				}
			}
		})();
	}, []);

	//se algum erro acontecer de ir um item undefined pra lista, eu tiro ele. Deixar aqui só por garantia
	useLayoutEffect(() => {
		if (itensOnPhone.some((item) => item === undefined)) {
			setItensOnPhone((prevItems) =>
				prevItems.filter((item) => item !== undefined)
			);
		}
	}, [itensOnPhone]);

	return (
		<S.container>
			{isLoad ? (
				<S.centralize>
					<Load showText text="Carregando..." />
				</S.centralize>
			) : (
				<>
					<MobileBody
						showFaceId={false}
						widthCellPhone={returnWidthPhone()}
						heightCellPhone={returnHeihtPhone()}
						isShadow
						backgroundColor={
							isDragging
								? color.interface.backgroundHome
								: color.interface.backgroundHome
						}
					>
						<S.containerListCellphone $isDraggingOver={isDragging}>
							{itensOnPhone.length > 0 ? (
								<>
									{itensOnPhone.map((item, index) => (
										<S.boxItem
											key={item?.id}
											onMouseOver={() =>
												toogleSelectModuleToEditOrDelete(item, true)
											}
											onMouseOut={() =>
												toogleSelectModuleToEditOrDelete(item, false)
											}
										>
											<SortableItem
												styleProps={{ backgroundColor: 'red' }}
												id={item?.id || index}
											>
												<S.itemCellphone $isDragging={isDragging}>
													{returnInterfaceBySlug(item)}
												</S.itemCellphone>
											</SortableItem>

											{((width && width < 1000) || item?.isEdit) &&
												!isDragging && (
													<S.optionsItem>
														<p>Ações:</p>
														<div>
															<S.editModule onClick={() => editItem(item)}>
																<MdEdit />
															</S.editModule>

															<S.deleteModule onClick={() => deleteItem(item)}>
																<MdDelete />
															</S.deleteModule>
														</div>
													</S.optionsItem>
												)}
										</S.boxItem>
									))}
								</>
							) : (
								<S.centralize>
									<SortableItem id={0}>
										<S.noDataText>Não há módulos cadastrados</S.noDataText>
									</SortableItem>
								</S.centralize>
							)}
						</S.containerListCellphone>
					</MobileBody>
					<S.saveBtn
						$listAreEqual={isEqual}
						onClick={async () => {
							if (!isEqual) {
								saveIntensPosition();
							}
						}}
					>
						<button>{isEqual ? 'Publicado' : 'Publicar'}</button>
						{isEqual ? <MdOutlinePublishedWithChanges /> : <FaSave />}
					</S.saveBtn>
				</>
			)}
		</S.container>
	);
}
